// One global cooldown shared by every AI opt-in nudge (voice, echo, journal,
// home). Per-surface timers would let four surfaces each ask once a week, which
// is four times the nagging for no extra clarity.
//
// Mirrors mobile's LocalPrefs.aiNudge* so the two clients behave identically.

const LAST_SHOWN_KEY = 'mindwire.aiNudgeLastShown.v1';
const SILENCED_KEY = 'mindwire.aiNudgeSilenced.v1';

export const AI_NUDGE_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

// Private browsing and blocked-storage modes throw on access. Every helper
// degrades to "stay quiet", which is the safe default for a prompt.
function readItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* non-fatal: the nudge simply reappears next time */
  }
}

export function aiNudgeAllowed(now = Date.now()) {
  try {
    if (readItem(SILENCED_KEY) === 'true') return false;
    const raw = readItem(LAST_SHOWN_KEY);
    if (!raw) return true;
    const last = Date.parse(raw);
    if (Number.isNaN(last)) return true; // corrupt value — treat as never shown
    return now - last >= AI_NUDGE_COOLDOWN_MS;
  } catch {
    return false;
  }
}

export function markAiNudgeShown(now = Date.now()) {
  writeItem(LAST_SHOWN_KEY, new Date(now).toISOString());
}

// "Don't ask again" — permanent until the user turns AI on themselves.
export function silenceAiNudges() {
  writeItem(SILENCED_KEY, 'true');
}

// Cleared when consent is granted, so a later pause starts from a clean slate
// rather than inheriting an old silence.
export function resetAiNudges() {
  try {
    window.localStorage.removeItem(SILENCED_KEY);
    window.localStorage.removeItem(LAST_SHOWN_KEY);
  } catch {
    /* non-fatal */
  }
}
